import { apiClient } from './client'

export interface CatalogTool {
  name: string
  description: string
  group: string // core|graph|usability|management|other
}

export interface ToolCatalogResponse {
  tools: CatalogTool[]
}

export const toolSelectionAPI = {
  getCatalog: () => apiClient.get<ToolCatalogResponse>('/chat/tool-catalog').then((r) => r.data),
  getDefaults: () =>
    apiClient.get<{ enabled_tools: string[] }>('/chat/tool-defaults').then((r) => r.data),
  setDefaults: (enabled_tools: string[]) =>
    apiClient
      .put<{ enabled_tools: string[] }>('/chat/tool-defaults', { enabled_tools })
      .then((r) => r.data),
  getConversationTools: (uuid: string) =>
    apiClient
      .get<{ enabled_tools: string[] | null }>(`/chat/conversations/${uuid}/tools`)
      .then((r) => r.data),
  addConversationTools: (uuid: string, enable: string[]) =>
    apiClient
      .patch<{ enabled_tools: string[] | null }>(`/chat/conversations/${uuid}/tools`, { enable })
      .then((r) => r.data),
}
